import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import injectSheet from 'react-jss';

import routes from '../helpers/ApplicationRoutes';
import Avatar from './Avatar';

const MenuItem = ({ organization, selected, onClick, classes }) => {
    const itemClasses = classNames({ [classes.selected]: selected });
    return (
        <ListItem
            onClick={onClick}
            component={Link}
            className={classes.background}
            to={routes.organization.getPath({
                organizationId: organization.id,
            })}
        >
            <div className={classes.itemWrapper}>
                <Avatar
                    alt={organization.name}
                    src={organization.pictureSmallURL}
                    className={classes.avatar}
                />
                <Typography className={itemClasses} noWrap>
                    {organization.name}
                </Typography>
            </div>
        </ListItem>
    );
};

MenuItem.propTypes = {
    organization: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    selected: PropTypes.bool,
};

MenuItem.defaultProps = {
    selected: false,
};

const style = ({ palette, spacing, menu }) => ({
    background: {
        '&:hover': {
            backgroundColor: palette.background.gray1Color,
        },
    },
    itemWrapper: {
        display: 'flex',
        alignItems: 'center',
        maxWidth: menu.width - spacing.unit * 6,
    },
    selected: {
        color: palette.primary.main,
    },
    avatar: {
        marginRight: spacing.unit * 2,
    },
});

export default injectSheet(style)(MenuItem);



// WEBPACK FOOTER //
// ./src/components/MenuItem.js